import { apiValidateFPEmail } from '@/api/resetPassword'

export function validate_email(rule, value, callback) {
    // 邮箱
    if (!value) {
        return callback(new Error(this.$t('Validate.Email.IsNull')))
    }

    if (value.length > 100) {
        return callback(new Error(this.$t('Validate.StringLength.Length100')))
    }

    // 邮箱格式验证
    // const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+[\.][a-zA-Z0-9_-]+$/
    const reg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,12})+$/
    if (!reg.test(value)) {
        return callback(new Error(this.$t('Validate.Email.IsCorrect')))
    }

    // 验证邮箱是否注册过
    apiValidateFPEmail({ email: value }).then(response => {
        if (response.status === 200) {
            callback()
        } else {
            return callback(new Error(this.$t('Validate.Email.IsUnregistered')))
        }
    })
}

export function validate_phone(rule, value, callback) {
    // 手机号
    if (!value) {
        return callback(new Error(this.$t('Validate.Phone.IsNull')))
    }

    const reg = /^1[0-9]{10}$/
    if (!reg.test(value)) {
        return callback(new Error(this.$t('Validate.Phone.PhoneNumber')))
    }

    callback()
}

export function validate_password(rule, value, callback) {
    // 密码
    if (!value) {
        return callback(new Error(this.$t('Validate.Password.IsNull')))
    }

    const reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).[^\s]{5,19}$/ //密码校验
    if (!reg.test(value)) {
        return callback(new Error(this.$t('Validate.NewPassword.IsCorrect')))
    }

    callback()
}

export function validate_confirmPassword(rule, value, callback) {
    // 确认密码
    if (!value) {
        return callback(new Error(this.$t('Validate.ConfirmPassword.IsNull')))
    }
    let newPassword = (this.form && this.form.newPassword) || ''
    if (value !== newPassword) {
        return callback(new Error(this.$t('Validate.ConfirmPassword.NotSame')))
    }
    callback()
}
